import React, { Fragment } from "react";
import { Typography, Box, Button, Link, Grid } from "@material-ui/core";
import { useStyles } from "../Theme.js";

const Pourquoi = () => {
  const classes = useStyles();
  return (
    <Fragment>
      <Box
        className={classes.subHeader}
        style={{
          marginTop: 20,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: "0",
        }}
      >
        <Typography
          variant="h3"
          className={classes.subHeaderTitle}
          style={{ textAlign: "center", display: "block" }}
        >
          Pourquoi participer ?
        </Typography>
        <Typography variant="body1" style={{ fontSize: 12 }}>
          Votre participation est précieuse pour le territoire !...
        </Typography>
      </Box>
      <Typography variant="body2" style={{ padding: "0 30px" }}>
        <p>En participant, vous permettez au territoire</p>
        <ul>
          <li>
            De mieux comprendre comment vous percevez le tourisme et ses effets
            sur le territoire
          </li>
          <li>
            D’identifier des points d’amélioration à apporter : aménagements,
            équipements, information…
          </li>
          <li>
            De mettre les études génériques en perspective avec vos propos
            recueillis en un instant donné et à un endroit précis
          </li>
        </ul>
        <p>
          <em>… et donc pour vous !</em>
        </p>
        <p>Votre participation vous permet :</p>
        <ul>
          <li>
            D’accéder aux informations partagées par les autres utilisateurs,
            par la constitution d’une communauté ;
          </li>
          <li>De cumuler des points pour bénéficier de récompenses ;</li>
          <li>
            A terme, de profiter des améliorations mises en œuvre sur le
            territoire
          </li>
        </ul>
      </Typography>
    </Fragment>
  );
};

export default Pourquoi;
